import { __awaiter, __generator } from "tslib";
import { ActionsMenuButtonKey as ActionsMenuButtonKey } from '.';
import { popoverDriver } from '../../primitives/drivers';
export var createActionsMenuButtonDriver = function (wrapper, global) {
    var base = wrapper.$("." + ActionsMenuButtonKey);
    var popover = popoverDriver(global);
    return {
        openMenu: function () { return base.$('.actions-button').click(); },
        getMenuDriver: function () { return popover.$('.actions-menu-body'); },
        isDisabled: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.actions-button').hasClass('disabled')];
        }); }); },
        isHorizontal: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.actions-button').hasClass('horizontal')];
        }); }); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map